<div class="footer">
  <div class="row">
    <div class="col text-center">
      Auxiliar:
      <strong>{{ this.service.caja.vendedor.nombre | uppercase }}</strong>
    </div>
    <div class="col text-center">
      Impresora: <strong>{{ this.service.impresora }}</strong>
    </div>
    <div class="col text-center">
      Abierta: <strong>{{ tiempo }}</strong>
    </div>
    <div class="col text-center">
      Version: <strong>{{ texto }}</strong>
    </div>
  </div>
</div>
